import { Link } from "react-router-dom";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-white/10 bg-navy text-slate-300"
    >
      <div className="mx-auto max-w-6xl px-4 pb-24 pt-14 sm:px-6 md:pb-14">
        <div className="mb-10">
          <Logo onDark />
          <p className="mt-3 text-sm text-slate-400">
            Websites that answer the call when you can't.
          </p>
        </div>

        <div className="space-y-2 text-sm" data-testid="footer-business-info">
          <p data-testid="footer-owner-line" className="font-medium text-slate-200">
            Web Pilot · Zachary Laboyteaux, Owner
          </p>
          <p data-testid="footer-serving-line">Serving the Indianapolis area</p>
          <p
            data-testid="footer-service-area-line"
            className="leading-relaxed text-slate-400"
          >
            <span className="font-medium text-slate-300">Service area:</span>{" "}
            Indianapolis, Carmel, Fishers, Noblesville, Westfield, Zionsville,
            Greenwood, Plainfield, Avon, Brownsburg
          </p>
          <p className="pt-2" data-testid="footer-contact-line">
            <a
              href="mailto:zach@webpilot.agency"
              data-testid="footer-email-link"
              className="text-skyblue hover:underline"
            >
              zach@webpilot.agency
            </a>
            <span className="mx-2 text-slate-500">·</span>
            <a
              href="tel:+13174982575"
              data-testid="footer-phone-link"
              className="text-skyblue hover:underline"
            >
              317-498-2575
            </a>
            <span className="mx-2 text-slate-500">·</span>
            <span>Hours: Mon–Fri 8am–6pm ET</span>
          </p>
        </div>

        <div
          className="mt-8 flex flex-wrap gap-x-5 gap-y-2 text-xs text-slate-400"
          data-testid="footer-legal-links"
        >
          <Link to="/privacy" className="hover:text-white hover:underline">
            Privacy Policy
          </Link>
          <Link to="/terms" className="hover:text-white hover:underline">
            Terms of Service
          </Link>
          <Link to="/sms-terms" className="hover:text-white hover:underline">
            SMS Terms
          </Link>
        </div>

        <p className="mt-6 text-xs text-slate-500" data-testid="footer-copyright">
          © 2026 Web Pilot
        </p>
      </div>
    </footer>
  );
}
